module.exports = __webpack_public_path__ + "static/bee-biomedical-0e5a26f4a647d438f44e87af0e017943.jpg";